module.exports = __webpack_public_path__ + "img/success.463e0e39.svg";